/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingRuleAllocationProportionalSpend extends models.BillingRuleAllocationGenericTargets {
    constructor() {
        super();
        this.setDiscriminator("BillingRuleAllocationProportionalSpend");
    }

    getFixupPrototypeFunction() { return BillingRuleAllocationProportionalSpend.fixupPrototype; }

    static newInstance(model: Partial<BillingRuleAllocationProportionalSpend>): BillingRuleAllocationProportionalSpend {
        let obj = Object.assign(new BillingRuleAllocationProportionalSpend(), model);
        BillingRuleAllocationProportionalSpend.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingRuleAllocationProportionalSpend>): BillingRuleAllocationProportionalSpend {
        if (!model) return null;
        return BillingRuleAllocationProportionalSpend.newInstance(<BillingRuleAllocationProportionalSpend> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingRuleAllocationProportionalSpend) {
        if (!obj) return;

        models.BillingRuleAllocationProportionalSpend.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingRuleAllocationProportionalSpend): boolean {
        if (models.BillingRuleAllocationGenericTargets.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingRuleAllocationProportionalSpend.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
